import React, { useState } from "react";
import styles from "./SearchAll.module.scss";
import InputForms from "../../UiComponents/forms/InputForms";
import { normalize } from "../../../utils/fonctionSearch";



const SearchAll = ({
    allUser,
    allCabines,
    changeOwnerIdWithSelect,
    changeCabIdWithSelect,
    ownerId,
    infosCabId,
  }) => {
    const [search, setSearch] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    
    
    const normalizedSearch = normalize(search);


 
const filteredUser = allUser.filter((u) =>
  [u.display_name, u.user_email, u.ID.toString(), u.user_login].some((field) =>
    normalize(field).includes(normalizedSearch)
  )
);

const filteredCabines = allCabines.filter((c) =>
  [c.cabname, c.id.toString()].some((field) =>
    normalize(field).includes(normalizedSearch)
  )
);
  
    // Handlers pour sélection
    const handleSelectUser = (e) => {
      changeOwnerIdWithSelect(e);
      setSearch(""); // reset input
      setIsSearching(false); // hide selects
    };
  
    const handleSelectCabine = (e) => {
      changeCabIdWithSelect(e);
      setSearch("");
      setIsSearching(false);
    };
  
    return (
      <div className={styles.containerSearchAll}>
        <InputForms
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setIsSearching(true);
          }}
          
          placeholder={"Rechercher un utilisateur ou une cabine"}
          id={styles.searchAll}
        />
  
        {isSearching && (
          <div className={styles.results}>
            <div className={styles.group}>
              <p className={styles.groupTitle}>Utilisateurs</p>
              <select
                value={ownerId}
                onChange={handleSelectUser}
                size={filteredUser.length > 0 ? 6 : 1}
                onBlur={() => setIsSearching(false)}
              >
                <option value="">-- Sélectionnez un utilisateur --</option>
                {filteredUser.length === 0 ? (
                  <option disabled>Aucun utilisateur trouvé</option>
                ) : (
                  filteredUser.map((u) => (
                    <option key={u.ID} value={u.ID}>
                      {u.user_login} {u.display_name} ({u.ID})
                    </option>
                  ))
                )}
              </select>
            </div>
  
            <div className={styles.group}>
              <p className={styles.groupTitle}>Cabines</p>
              <select
                value={infosCabId}
                onChange={handleSelectCabine}
                size={filteredCabines.length > 0 ? 6 : 1}
                onBlur={() => setIsSearching(false)}
              >
                <option value="">-- Sélectionnez une cabine --</option>
                {filteredCabines.length === 0 ? (
                  <option disabled>Aucune cabine trouvée</option>
                ) : (
                  filteredCabines.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.cabname} ({c.id})
                    </option>
                  ))
                )}
              </select>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default SearchAll;